/**
 * Scrolls to a specific section and focuses the first interactive element
 * @param {Object} sectionRefs - Object containing section refs keyed by viewId
 * @param {string} viewId - The ID of the view/section to scroll to
 */
export function scrollToSection(sectionRefs, viewId) {
  const section = sectionRefs[viewId];
  if (!section) return;

  // Check user preference for reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll to section
  section.scrollIntoView({
    behavior: prefersReducedMotion ? 'auto' : 'smooth',
    block: 'start',
  });

  // Focus first interactive element after scroll
  // Use requestAnimationFrame to ensure scroll completes first
  requestAnimationFrame(() => {
    const focusable = section.querySelector(
      'input:not([disabled]), ' +
      'select:not([disabled]), ' +
      'textarea:not([disabled]), ' +
      'button:not([disabled]), ' +
      '[tabindex]:not([tabindex="-1"])'
    );

    if (focusable) {
      focusable.focus({ preventScroll: true });
    }
  });
}